import React, { useLayoutEffect, useRef } from 'react';
import { findDecodedFeedImage } from '../../utils/feedImageCache';

function paintCutout(canvas, source) {
  if (!canvas || !source) return false;
  const w = source.naturalWidth || source.width;
  const h = source.naturalHeight || source.height;
  if (!w || !h) return false;
  if (canvas.width !== w) canvas.width = w;
  if (canvas.height !== h) canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) return false;
  try {
    ctx.drawImage(source, 0, 0, w, h);
    return true;
  } catch {
    return false;
  }
}

/**
 * Popup cutout: copy the carousel's already-decoded pixels onto a canvas before
 * the first paint so the photo is on screen in the same frame as the click.
 * cloneNode/<img src> would start a new decode and flash empty.
 */
export function ReusedFeedImg({ src, className, alt = '' }) {
  const canvasRef = useRef(null);
  const decoded = src ? findDecodedFeedImage(src) : null;

  useLayoutEffect(() => {
    const canvas = canvasRef.current;
    const source = findDecodedFeedImage(src);
    if (!canvas || !source) return;
    paintCutout(canvas, source);
  }, [src]);

  if (!src) return null;

  if (decoded) {
    return (
      <canvas
        ref={(el) => {
          canvasRef.current = el;
          if (el) paintCutout(el, decoded);
        }}
        className={className}
        role="img"
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
      />
    );
  }

  return <img src={src} alt={alt} className={className} decoding="sync" />;
}
